// Configuration des écoles et univers
// Les écoles sont détectées par sous-domaine (ex: iscpa.dailyglobe.school)

// URLs des assets
export const ASSETS = {
  // Logos principaux - Logo outline DailyGlobe (transparent)
  DAILYGLOBE_LOGO: 'https://customer-assets.emergentagent.com/job_775b1c44-a958-4f0a-89e7-e9533aa80b3a/artifacts/n6am8he0_IMG_1574.png',
  // Super Reporter (on utilise la houppe de Petit XXème comme fallback si Super Reporter non dispo)
  SUPER_REPORTER: 'https://customer-assets.emergentagent.com/job_775b1c44-a958-4f0a-89e7-e9533aa80b3a/artifacts/w42vvg36_A54EF02E-1119-479A-93BB-C55EC73861F3.jpeg',
  
  // Personnages Univers Super-Héros
  SUPER_RED_CHIEF: 'https://static.prod-images.emergentagent.com/jobs/89fa0a8d-4789-46cb-82c0-3e236fda6d73/images/ec4fe6bfafad43ee5fdf02c114d98cf0e3d4a87fd04da4f952922a84bc2c68fb.png',
  SUPER_SEO_GIRL: 'https://static.prod-images.emergentagent.com/jobs/89fa0a8d-4789-46cb-82c0-3e236fda6d73/images/59098c895608c851c79d09e223d693ee144ff7ad1a23f17ec332913b7f131487.png',
  SUPER_INTERVIEWER: 'https://static.prod-images.emergentagent.com/jobs/89fa0a8d-4789-46cb-82c0-3e236fda6d73/images/2d047aaba6af199bc1fc42b10188d46ec9e6efeb1132a1e1aa59dc84c4f571d9.png',
  SUPER_FACT_CHECKER: 'https://static.prod-images.emergentagent.com/jobs/89fa0a8d-4789-46cb-82c0-3e236fda6d73/images/8e8291414444887d87fc50ec782084428d275340bd81be686ae6fc45d486f669.png',
  SUPER_PITCHER: 'https://static.prod-images.emergentagent.com/jobs/89fa0a8d-4789-46cb-82c0-3e236fda6d73/images/3b23d99d5758206b1296f8428310d2fd00df6b20fa91a18624913ddd808add67.png',
  
  // Personnages Univers Globe-Trotter
  PETIT_XXEME: 'https://customer-assets.emergentagent.com/job_31d2b399-0d79-4473-8cfb-5ff56d3e51cb/artifacts/sb1tpnft_tintin.png',
  ARCHIBALD: 'https://customer-assets.emergentagent.com/job_31d2b399-0d79-4473-8cfb-5ff56d3e51cb/artifacts/kwth5cv4_haddock.png',
  TRIPHON: 'https://customer-assets.emergentagent.com/job_31d2b399-0d79-4473-8cfb-5ff56d3e51cb/artifacts/gdgh52tf_tournesol.png',
  BIANCA: 'https://customer-assets.emergentagent.com/job_31d2b399-0d79-4473-8cfb-5ff56d3e51cb/artifacts/wkq1s4og_castafiore.png',
  LES_POLICIERS: 'https://customer-assets.emergentagent.com/job_31d2b399-0d79-4473-8cfb-5ff56d3e51cb/artifacts/m9dogmoo_dupont%20dupond.png',
  SERAPHIN: 'https://customer-assets.emergentagent.com/job_31d2b399-0d79-4473-8cfb-5ff56d3e51cb/artifacts/je7kick2_lampion.png',
  NESTOR: 'https://customer-assets.emergentagent.com/job_31d2b399-0d79-4473-8cfb-5ff56d3e51cb/artifacts/sfu6yo27_nestor.png',
  ALCAZAR: 'https://customer-assets.emergentagent.com/job_31d2b399-0d79-4473-8cfb-5ff56d3e51cb/artifacts/0xaqtja2_alcazar.png',
  
  // Logos écoles
  ISCPA_LOGO: 'https://customer-assets.emergentagent.com/job_775b1c44-a958-4f0a-89e7-e9533aa80b3a/artifacts/ln1xae1h_IMG_1575.png',
  ILDJ_LOGO: 'https://customer-assets.emergentagent.com/job_31d2b399-0d79-4473-8cfb-5ff56d3e51cb/artifacts/lyfvft2n_image.png'
};

// Univers disponibles
export const UNIVERSES = {
  SUPER_HERO: 'super_hero',
  GLOBE_TROTTER: 'globe_trotter'
};

// Personnages de l'univers Super-Héros
export const SUPER_HERO_CHARACTERS = {
  main: {
    name: 'Super Reporter',
    image: ASSETS.SUPER_REPORTER,
    role: 'guide',
    quotes: [
      "En avant, futur super reporter !",
      "Ta mission : traquer la vérité !",
      "Un bon journaliste ne lâche jamais l'affaire !",
      "Prêt pour une nouvelle aventure ?",
      "Avec tes super pouvoirs, rien n'est impossible !",
      "La vérité est notre super pouvoir !"
    ]
  },
  superSeoGirl: {
    name: 'Super SEO Girl',
    image: ASSETS.SUPER_SEO_GIRL,
    role: 'seo_coach',
    quotes: [
      "Les mots-clés sont mes super pouvoirs !",
      "Google n'a aucun secret pour moi !",
      "Un bon titre vaut mille backlinks !",
      "Meta description activée !",
      "Optimise ton contenu, héros du web !",
      "Le référencement est un art... et tu vas le maîtriser !"
    ]
  },
  superRedChief: {
    name: 'Super Red Chief',
    image: ASSETS.SUPER_RED_CHIEF,
    role: 'grammar_coach',
    quotes: [
      "Pas de faute dans MON journal !",
      "Une virgule mal placée, c'est une info mal comprise !",
      "La grammaire est le bouclier du journaliste !",
      "Relecture activée ! Mode sans pitié !",
      "Ton article sera parfait ou ne sera pas !",
      "Les coquilles sont mes ennemis jurés !"
    ]
  },
  superInterviewer: {
    name: 'Super Interviewer',
    image: ASSETS.SUPER_INTERVIEWER,
    role: 'interview_coach',
    quotes: [
      "Une bonne question vaut mieux qu'une longue réponse !",
      "Je lis dans les pensées... enfin presque !",
      "L'écoute est mon super pouvoir secret !",
      "Fais parler tes sources !",
      "La relance parfaite, c'est mon spécial !",
      "Chaque interview est une enquête !"
    ]
  },
  superFactChecker: {
    name: 'Super Fact-Checker',
    image: ASSETS.SUPER_FACT_CHECKER,
    role: 'factcheck_coach',
    quotes: [
      "FAUX ! Vérifie tes sources !",
      "La désinformation ne passera pas !",
      "Une source, c'est bien. Deux, c'est mieux !",
      "Mon radar anti-fake news est activé !",
      "La vérité est ma mission !",
      "Toujours croiser les informations !"
    ]
  },
  superPitcher: {
    name: 'Super Pitcher',
    image: ASSETS.SUPER_PITCHER,
    role: 'pitch_coach',
    quotes: [
      "Un bon angle, c'est la moitié du travail !",
      "Pitch parfait en 3... 2... 1... GO !",
      "Trouve l'angle que personne n'a vu !",
      "Ta conférence de rédaction commence maintenant !",
      "Un sujet banal ? Trouve-lui un angle génial !",
      "Les meilleures histoires sont partout autour de toi !"
    ]
  }
};

// Personnages de l'univers Globe-Trotter (inspiré BD classique)
export const GLOBE_TROTTER_CHARACTERS = {
  petitXXeme: {
    name: 'Reporter Petit XXème',
    image: ASSETS.PETIT_XXEME,
    role: 'guide',
    quotes: [
      "J'ai encore suivi une fausse piste !",
      "Il y a quelque chose de louche dans cette affaire...",
      "Allons-y ! L'aventure nous attend !",
      "Je flaire un scoop !",
      "Cette piste mène quelque part, j'en suis sûr !"
    ]
  },
  archibald: {
    name: 'Le Capitaine',
    altName: 'Archibald',
    image: ASSETS.ARCHIBALD,
    role: 'grammar_coach',
    quotes: [
      "Tonnerre de Brest !",
      "Mille sabords ! Cette faute est impardonnable !",
      "Mille millions de mille sabords !",
      "Bachi-bouzouk ! Relisez-moi ça !",
      "Moule à gaufres ! C'est quoi cette orthographe ?",
      "Espèce de marin d'eau douce !",
      "Crétin des Alpes !"
    ]
  },
  triphon: {
    name: 'Le Professeur',
    altName: 'Triphon',
    image: ASSETS.TRIPHON,
    role: 'tech_coach',
    quotes: [
      "Un peu plus à l'ouest !",
      "Pardon ? Vous disiez ?",
      "Ah, fascinant ! Absolument fascinant !",
      "Je suis en train de terminer mes calculs...",
      "C'est une question de fréquences, voyez-vous.",
      "Merci, capitaine, merci ! Je n'en attendais pas moins de vous !"
    ]
  },
  bianca: {
    name: 'La Diva',
    altName: 'Bianca',
    image: ASSETS.BIANCA,
    role: 'interview_coach',
    quotes: [
      "Ah, je ris !",
      "Ah ! Ciel ! Quelle question mal formulée !",
      "Mon cher ami ! Comme je suis heureuse !",
      "Vous permettez que je vous appelle mon ami ?",
      "Ah ! Ces bijoux ! Ils ont une telle histoire !"
    ]
  },
  lesPoliciers: {
    name: 'Les Policiers',
    image: ASSETS.LES_POLICIERS,
    role: 'factcheck_coach',
    quotes: [
      "Je dirais même plus...",
      "C'est mon opinion et je la partage !",
      "Pour une fois que nous tenions les coupables, il faut qu'ils s'arrangent pour être innocents !",
      "Hauts les mains, poum poum !",
      "Je vous avais pourtant bien dit de faire attention !",
      "Cette lettre est une lettre anonyme dont l'auteur est inconnu !"
    ]
  },
  seraphin: {
    name: 'Séraphin',
    image: ASSETS.SERAPHIN,
    role: 'seo_coach',
    quotes: [
      "J'ai justement ce qu'il vous faut !",
      "Entre nous, c'est une affaire en or !",
      "Vous ne le regretterez pas !",
      "Ah ! Quel plaisir de vous revoir !",
      "Je passais justement dans le quartier..."
    ]
  },
  nestor: {
    name: 'Nestor',
    image: ASSETS.NESTOR,
    role: 'butler',
    quotes: [
      "Si Monsieur veut bien se donner la peine...",
      "Le quiz de Monsieur est servi.",
      "Monsieur a appelé ?",
      "Bien, Monsieur.",
      "Je me permets de suggérer à Monsieur..."
    ]
  },
  alcazar: {
    name: 'Le Général',
    altName: 'Alcazar',
    image: ASSETS.ALCAZAR,
    role: 'bonus',
    quotes: [
      "Caramba !",
      "Por todos los diablos !",
      "Viva la révolution !",
      "C'est une question d'honneur !"
    ]
  }
};

// Configuration des écoles
export const SCHOOLS_CONFIG = {
  // École par défaut (démo)
  default: {
    id: 'dailyglobe',
    name: 'DailyGlobe School',
    logo: null, // Pas de logo école en mode démo
    showSchoolLogo: false,
    tagline: 'Deviens un super reporter !',
    primaryColor: '#1B4965',
    accentColor: '#E63946'
  },
  
  // ISCPA
  iscpa: {
    id: 'iscpa',
    name: 'ISCPA',
    logo: ASSETS.ISCPA_LOGO,
    showSchoolLogo: true,
    tagline: 'Apprends le métier de super reporter avec ISCPA !',
    primaryColor: '#1B4965',
    accentColor: '#FF6B35'
  },
  
  // ILDJ
  ildj: {
    id: 'ildj',
    name: 'Institut Libre de Journalisme',
    logo: ASSETS.ILDJ_LOGO,
    showSchoolLogo: true,
    tagline: 'La liberté d\'informer commence ici !',
    primaryColor: '#1B4965',
    accentColor: '#2563eb'
  }
};

// Détecter l'école depuis le sous-domaine OU le paramètre URL ?school=
export const getSchoolFromSubdomain = () => {
  // 1. Check URL parameter first (for testing): ?school=iscpa
  const urlParams = new URLSearchParams(window.location.search);
  const schoolParam = urlParams.get('school');
  
  if (schoolParam) {
    const schoolKey = schoolParam.toLowerCase();
    if (SCHOOLS_CONFIG[schoolKey]) {
      return SCHOOLS_CONFIG[schoolKey];
    }
  }
  
  // 2. Check subdomain
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  
  if (parts.length >= 2) {
    const subdomain = parts[0].toLowerCase();
    
    if (subdomain === 'iscpa') {
      return SCHOOLS_CONFIG.iscpa;
    }
    if (subdomain === 'ildj') {
      return SCHOOLS_CONFIG.ildj;
    }
  }
  
  // 3. Default: demo mode
  return SCHOOLS_CONFIG.default;
};

// Obtenir l'école courante
export const getCurrentSchool = () => {
  return getSchoolFromSubdomain();
};

// Obtenir l'univers courant
export const getCurrentUniverse = () => {
  return localStorage.getItem('selectedUniverse') || UNIVERSES.SUPER_HERO;
};

// Définir l'univers
export const setCurrentUniverse = (universe) => {
  localStorage.setItem('selectedUniverse', universe);
};

// Obtenir les personnages selon l'univers
export const getCharacters = () => {
  const universe = getCurrentUniverse();
  if (universe === UNIVERSES.GLOBE_TROTTER) {
    return GLOBE_TROTTER_CHARACTERS;
  }
  return SUPER_HERO_CHARACTERS;
};

// Obtenir une citation aléatoire d'un personnage
export const getRandomQuote = (character) => {
  const quotes = character.quotes || [];
  return quotes[Math.floor(Math.random() * quotes.length)] || '';
};

// Obtenir le personnage guide principal
export const getMainGuide = () => {
  const universe = getCurrentUniverse();
  if (universe === UNIVERSES.GLOBE_TROTTER) {
    return GLOBE_TROTTER_CHARACTERS.petitXXeme;
  }
  return SUPER_HERO_CHARACTERS.main;
};

// Obtenir le coach pour un module spécifique
export const getCoachForModule = (moduleId) => {
  const universe = getCurrentUniverse();
  
  if (universe === UNIVERSES.GLOBE_TROTTER) {
    const moduleCoaches = {
      'grammar': GLOBE_TROTTER_CHARACTERS.archibald,
      'daily_quiz': GLOBE_TROTTER_CHARACTERS.nestor,
      'interview': GLOBE_TROTTER_CHARACTERS.bianca,
      'seo': GLOBE_TROTTER_CHARACTERS.seraphin,
      'pitch': GLOBE_TROTTER_CHARACTERS.petitXXeme,
      'typing_game': GLOBE_TROTTER_CHARACTERS.archibald,
      'press_history': GLOBE_TROTTER_CHARACTERS.triphon,
      'media_economics': GLOBE_TROTTER_CHARACTERS.seraphin,
      'who_is_who': GLOBE_TROTTER_CHARACTERS.lesPoliciers
    };
    return moduleCoaches[moduleId] || GLOBE_TROTTER_CHARACTERS.petitXXeme;
  }
  
  return SUPER_HERO_CHARACTERS.main;
};

// Export pour compatibilité
export const SUPER_REPORTER_IMAGE = ASSETS.SUPER_REPORTER;
